module.exports = __webpack_public_path__ + "media/images/crosswords/pos4-00e374b82322af80dea1237daea4487d.png";